import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Space, Radio,message, Spin } from "antd";
import Bridge from "../../utils/Bridge";
import {
  speech_voice_recording_content_part_1,
  speech_voice_recording_content_part_2,
  speech_demographics_form_type
} from '../../utils/consts';

export default class VoiceRecording extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      if_agree_to_participate_in_study: "",
      if_you_no_question_and_agree_status:"",
      participation_attestation:"",
      field_data:[]
    };
  }
  componentDidMount() {
    this.get_demographic_details();
    this.get_speech_client_code()
  }
  get_speech_client_code=()=>{
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id");
        Bridge.demographics.speech
        .check_als_user(params)
        .then((response) => {
          if (response.status == "1") {
            if(response.data.is_voice_recording_is_completed==true){
              window.location.assign('/dashboard');
            }

          }else{
            this.setState({loading:false})
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
  }
  get_demographic_details = () => {
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&status=0';
    Bridge.participants.speech
    .get_voice_recording_details(params)
    .then((response) => {
      this.setState({ loading: false });
      if (response.status == "1") {

        
        for(let item of response.data.voice_recording_first_data){
          if(item.field=='FIRST_INIT'){
            this.setState({
              if_agree_to_participate_in_study:item.value
            })
          }
          if(item.field=='STDPART'){
            this.setState({
              if_you_no_question_and_agree_status:item.value
            })
          }
          if(item.field=='ATTEST'){
            this.setState({
              participation_attestation:item.value
            })
          }
        }
        
        this.setState({
          field_data: response.data.voice_recording_first_questions,
          loading: false
        })
      }
    })
    .catch((error) => {
      this.setState({ loading: false });
    });
  };
  save_details=()=>{
    if (!this.state.if_agree_to_participate_in_study) {
      message.warning("Please enter the value of 'If you agree to participate in this study option' field");
      window.scrollTo({
        top: document.getElementById("first_field").offsetTop,
        behavior: "smooth"
      });
      return;
    }
    if (!this.state.if_you_no_question_and_agree_status) {
      message.warning("Please choose one option");
      return;
    }
    if (this.state.if_you_no_question_and_agree_status==1) {
      if (!this.state.participation_attestation) {
        message.warning("Please enter participation attestation");
        return;
      }
    }
    let field_data=this.state.field_data
    const uniqueNames = [...new Map(field_data.map(item => [item.field, item])).values()];
    let questions=[]
    for(let item of uniqueNames){
      if(item.field=='FIRST_INIT'){
        let obj={
          value:this.state.if_agree_to_participate_in_study,
          view_name:item.view_name,
          form:"Voice Recording Acknowledgment",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='STDPART'){
        let obj={
            value:this.state.if_you_no_question_and_agree_status,
            view_name:item.view_name,
            form:"Voice Recording Acknowledgment",
            field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='ATTEST'){
        let obj={
            value:this.state.participation_attestation,
            view_name:item.view_name,
            form:"Voice Recording Acknowledgment",
            field: item.field
        }
        questions.push(obj)
      }
    }
    let params = {
      data: JSON.stringify(questions),
      participants_accounts_id:localStorage.getItem("ap_participants_accounts_id")
    };
    this.setState({ loading: true });
    Bridge.participants.speech
    .save_voice_recording(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          message.success(response.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              setTimeout(() => {
                window.location.assign("/dashboard");
              }, 3000);
            }
          );
        } else {
          message.error(response.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  }
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  <a href="/dashboard" className="back-arrow">
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    Dashboard
                  </a>
                  <div>
                    <div className="header">
                      <h3 className="text-uppercase">Voice Recording Acknowledgment</h3>
                      <div className="white-block"></div>
                    </div>
                    <div className="form-fields">
                      <Spin spinning={this.state.loading}>
                        <div className="consent-form-content">
                          {speech_voice_recording_content_part_1.map((item,index)=>{
                            return (
                              <p key={index}>{item}</p>
                            )
                          })}
                          <div className="form-group" id="first_field">
                            <p className="input-heading">Please note that this is not an ALS diagnosis or treatment study.</p>
                            <input
                              type="text"
                              name="if_agree_to_participate_in_study"
                              placeholder="If you agree to participate in this study option, please initial"
                              value={this.state.if_agree_to_participate_in_study}
                              onChange={(e) => {
                                this.setState({
                                  if_agree_to_participate_in_study: e.target.value,
                                });
                              }}
                              style={{ width: "100%", height: 55, maxWidth: 500 }}
                            />
                          </div>
                          {speech_voice_recording_content_part_2.map((item,index)=>{
                            return (
                              <p key={index}>{item}</p>
                            )
                          })} 
                          <div className="form-group">
                            <p className="input-heading">If you have no questions and agree to proceed, please select "YES"</p>
                            <Radio.Group
                              onChange={(e) => this.setState({ if_you_no_question_and_agree_status: e.target.value,participation_attestation:"" })}
                              value={this.state.if_you_no_question_and_agree_status}
                              direction="vertical"
                            >
                              <Space>
                                <Radio value={'1'}>Yes</Radio>
                                <Radio value={'2'}>No</Radio>
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <input
                              type="text"
                              name="participation_attestation"
                              placeholder="Participation Attestation (Initials)"
                              disabled={this.state.if_you_no_question_and_agree_status == 1?false:true}
                              value={this.state.participation_attestation}
                              onChange={(e) => {
                                this.setState({
                                  participation_attestation: e.target.value,
                                });
                              }}
                              style={{ width: "100%", height: 55, maxWidth: 500 }}
                            />
                          </div>
                          <button
                            className="submit-button"
                            style={{ padding: "9px 15px 10px 20px" }}
                            onClick={() => this.save_details()}
                          >
                            <box-icon
                              name="save"
                              type="solid"
                              color="#fff"
                              size={'17px'}
                              style={{ position: 'relative', top: -1, left: -11 }}
                            ></box-icon>
                            Save{" "}
                          </button>
                        </div>
                      </Spin>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
